import { useEffect, useState } from "react";
import AppRouter from "components/Router";
import {authService} from "fbase"

function App() {
  const [init, setInit] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userObj, setUserObj] = useState(null)
  useEffect(()=>{
    authService.onAuthStateChanged((user) => {
      if(user){
        setUserObj(user)
        setIsLoggedIn(true)
      } else {
        setIsLoggedIn(false)
      }
      setInit(true);
    })
  }, [])
  return (
    <>
      {init ? <AppRouter userObj={userObj} isLoggedIn={isLoggedIn} /> : <AppRouter isLoggedIn={isLoggedIn} />}
    </>
  )
}

export default App;
